var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.privilegeList.length > 0)?_c('PrivilegeCardMenu',{attrs:{"list":_vm.privilegeList,"title":'PRIVILEGE'}}):_vm._e(),(_vm.rewardList.length > 0)?_c('RewardListMenu',{attrs:{"list":_vm.rewardList,"title":'REWARD'}}):_vm._e(),(_vm.newsList.length > 0)?_c('NewsCardMenu',{attrs:{"list":_vm.newsList,"title":'NEWS'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }